import axios from 'axios';
import Swal from 'sweetalert2';

/**
 * Validador básico de dirección de correo electrónico
 */
export const isValidEmail = (email) => {
    if (!email || typeof email !== 'string') return false;
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email.trim());
};

/**
 * Función genérica y reutilizable para enviar comprobantes por correo electrónico
 * a cualquier endpoint del backend.
 * 
 * @param {Object} options
 * @param {string} options.url - Endpoint específico (ej: '/api/presupuestos/1/enviar-email/')
 * @param {string} options.email - Destinatario(s) separados por coma
 * @param {string} options.asunto - Asunto del correo
 * @param {string} [options.mensaje] - Mensaje personalizado
 * @param {string} [options.pdfBase64] - Documento adjunto en base64
 * @param {number|string} [options.companyId] - ID de empresa activa
 * @param {string} [options.successMessage] - Mensaje personalizado de éxito
 */
export const sendDocumentEmail = async ({
    url,
    email,
    asunto,
    mensaje = '',
    pdfBase64 = null,
    companyId = null,
    successMessage = 'El comprobante se envió correctamente por correo electrónico.'
}) => {
    if (!email || !email.trim()) {
        Swal.fire({
            title: 'Email Requerido',
            text: 'Por favor ingrese al menos una dirección de correo electrónico.',
            icon: 'warning',
            confirmButtonColor: '#3085d6'
        });
        return { success: false, error: 'Email requerido' };
    }

    try {
        const token = localStorage.getItem('token');
        const headers = {
            'Authorization': token ? `Token ${token}` : ''
        };
        if (companyId) {
            headers['X-Company-ID'] = companyId;
        }

        const payload = {
            email: email.trim(),
            asunto: asunto.trim(),
            mensaje: mensaje.trim(),
            pdf_base64: pdfBase64
        };

        const res = await axios.post(url, payload, { headers });

        if (res.data?.success) {
            Swal.fire({
                title: '¡Correo Enviado!',
                text: res.data.message || successMessage,
                icon: 'success',
                confirmButtonColor: '#3085d6'
            });
            return { success: true, data: res.data };
        } else {
            Swal.fire({
                title: 'Aviso',
                text: res.data?.error || 'No se pudo completar el envío del correo.',
                icon: 'warning',
                confirmButtonColor: '#3085d6'
            });
            return { success: false, error: res.data?.error };
        }
    } catch (error) {
        console.error('Error al enviar correo:', error);
        const errorMsg = error.response?.data?.error || error.message || 'Error de conexión con el servidor de correo.';
        Swal.fire({
            title: 'Error al enviar email',
            text: errorMsg,
            icon: 'error',
            confirmButtonColor: '#3085d6'
        });
        return { success: false, error: errorMsg };
    }
};
